import React from "react";
import { GQLOption, GQLOptionWithDescription } from "../../../schemas/schema";

interface IIsedEvaluationProps {
  essential_indicators: GQLOption[]
  additional_indicators: GQLOptionWithDescription[]
  checkedIndicators: (indicators: GQLOption[]) => GQLOption[]
  renderedEssentialIndicators: JSX.Element
  renderedAdditionalIndicators: JSX.Element
}

export const InnerModalEmphasisIndicators = (
  {
    essential_indicators,
    additional_indicators,
    checkedIndicators,
    renderedEssentialIndicators,
    renderedAdditionalIndicators
  }: IIsedEvaluationProps
) => {
  return <>
        { essential_indicators.length > 0 && (
            <>
                <h3 data-testid="indicators-tag-headline-essential" style={{ color: "black" }}>Essential</h3>
                <span className="nselected-category ">
              {checkedIndicators(essential_indicators).length} out of {essential_indicators.length} selected
            </span>
                { renderedEssentialIndicators }
                <hr/>
            </>
        )}
        { additional_indicators.length > 0 && (
            <>
                <h3 data-testid="indicators-tag-headline-additional" style={{ color: "black" }}>Additional</h3>
                <span className="nselected-category">
                {checkedIndicators(additional_indicators).length} out of {additional_indicators.length} selected
              </span>
                { renderedAdditionalIndicators }
            </>
        )}
    </>;
};
